import { CURRENT_CLIENT, useTenantLogoSrc } from '@yeshuman/sdk'

/** Tenant logo for candidate job browse/detail when org API omits a logo (e.g. TalentCo). */
export function useJobsBoardTenantLogoSrc(): string | undefined {
  const jobsBoard = (CURRENT_CLIENT as {
    jobsBoard?: { logoPath?: string; logoPathLight?: string }
    logoPath?: string
  }).jobsBoard
  const client = CURRENT_CLIENT as { logoPath?: string }

  return useTenantLogoSrc({
    logoPath: jobsBoard?.logoPath ?? client.logoPath,
    logoPathLight: jobsBoard?.logoPathLight,
    logoPathDark: jobsBoard?.logoPath,
  })
}
